import { PropsWithChildren } from 'react';

export type ServiceProviderProps<T> = Required<PropsWithChildren<{ value: T }>>;

export const isSuccess = (status: number | undefined) =>
  status && status >= 200 && status < 300;

export const isBadRequestError = (status: number | undefined) =>
  status && status === 400;

export const isAuthError = (status: number | undefined) =>
  status && status === 401;

export const isPaymentRequiredError = (status: number | undefined) =>
  status && status === 402;

export const isForbiddenError = (status: number | undefined) =>
  status && status === 403;

export const isNotFoundError = (status: number | undefined) =>
  status && status === 404;

export const isInvalidError = (status: number | undefined) =>
  status && status === 422;

export const isAllSuccess = (statuses: string[]) =>
  statuses.every((status) => status === 'success');

export const hasCode = (data: unknown): data is { code: string } =>
  typeof data === 'object' && data !== null && 'code' in data;

// eslint-disable-next-line
export type SecondParameter<T extends (...args: any) => any> = T extends (
  // eslint-disable-next-line
  config: any,
  args: infer P
  // eslint-disable-next-line
) => any
  ? P
  : never;

export enum ForbiddenCodeEnum {
  /** Error when user is in proxy login mode and action(create/update/delete) is not allowed */
  FORBIDDEN_MIMIC_MODE = 'FORBIDDEN_MIMIC_MODE',
}
